module.exports = __webpack_public_path__ + "img/function@2x.65557dca.png";